export enum UnitOfTime{
    MINUTES="Minutes",
    HOURS="Hours",
    DAYS="Days"
}